module.exports = __webpack_public_path__ + "img/Feature.8a6d0f50.jpg";